import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/call-type';
const API_DETAIL = (id: number) => `/call-type/${id}`;

export interface CallType {
  id: number;
  call_type_desc?: string;
}

export const useCallTypes = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<CallType[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    callTypes: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useCallType = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CallType>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    callType: data,
    isLoading,
    isError: error,
    mutate,
  };
};
